const angular = require('angular')
const map = require('lodash/map')
const filter = require('lodash/filter')

module.exports = ['$utils', '$translate', '$q', 'Message', 'User', 'DomUtils',
  function ($utils, $translate, $q, Message, User, DomUtils) {
    /** todo: StorageMailFolder, SearchMailFolder, KeywordSearchMail 三者冗余 */
    function StorageMailFolder(oMailFolderData) {
      if (!oMailFolderData) {
        throw 'FA_ILLEGAL_INIT_PARAM' //eslint-disable-line
      }

      const self = this
      DomUtils.copyProperties(self, oMailFolderData)
      self.latestMessageTime = null
      self.eariestMessageTime = null
      self.messages = []
      self.type = 'realFolder'
      self.filterFlags = {
      }
    }

    StorageMailFolder.prototype.loadMessages = function (iFid, iStart, iLimit) {
      const self = this
      iStart = iStart || 0
      iLimit = iLimit || 20
      const data = {
        fid: iFid,
        mode: 'count',
        order: 'receivedDate',
        desc: true,
        start: iStart,
        limit: iLimit,
        summaryWindowSize: iLimit,
        returnTotal: true,
        filterFlags: self.filterFlags,
        mboxa: User.getSelectedAccountSymbol()
      }
      return User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:listMessages',
          sid: User.getCurrentUser().sid
        },
        data
      })
    }
    // 获取当前邮件的前后加自身共三封邮件用于单点读信的前后页切换
    StorageMailFolder.prototype.getBeforeAfterMessages = function (fid, start, mid, mboxa) {
      return User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:listMessages',
          sid: User.getCurrentUser().sid
        },
        data: {
          fid: parseInt(fid),
          order: 'receivedDate',
          desc: true,
          start: start,
          limit: 3,
          returnTotal: true,
          summaryWindowSize: 3,
          offsetmid: mid,
          mboxa: mboxa === '' ? '' : mboxa || User.getSelectedAccountSymbol()
        }
      }).then(function (data) {
        if (data.code !== 'S_OK') return $q.reject(data)

        return Message.buildMessages(data.var || [])
      })
    }

    StorageMailFolder.prototype.fetchMessages = function (iStart, iLimit) {
      const self = this
      const deferred = $q.defer()
      self.loadMessages(self['id'], iStart, iLimit).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          const messages = Message.buildMessages(data['var'])
          self.totals = data.total
          if (messages.length > 0) {
            self.latestMessageTime = messages[0].messageInfo['sentDate']
            self.eariestMessageTime = messages[messages.length - 1].messageInfo['sentDate']
          }
          deferred.resolve(messages)
        } else {
          deferred.reject(code)
        }
      }, function (error) {
        console.log('listMessages: error: ' + JSON.stringify(error))
        deferred.reject(error)
      })

      return deferred.promise
    }

    /** todo: loadMoreMessages 完全可以调用 fetchMessages */
    StorageMailFolder.prototype.loadMoreMessages = function (iStart) {
      const self = this
      const deferred = $q.defer()

      /** has been loaded before */
      if (self.messages[iStart]) {
        deferred.resolve(deferred.resolve(self.messages.slice(iStart, iStart + 20)))
        return deferred.promise
      }

      self.loadMessages(self['id'], iStart).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          const messages = Message.buildMessages(data['var'])
          if (angular.isArray(self.messages) && self.messages.length > 0) {
            self.messages = self.messages.concat(messages)
          } else {
            self.messages = messages
          }
          if (self.messages.length > 0) {
            self.latestMessageTime = self.messages[0].messageInfo['sentDate']
            self.eariestMessageTime = self.messages[self.messages.length - 1].messageInfo['sentDate']
          }
          self.totals = data.total
          deferred.resolve(messages)
        } else {
          deferred.reject(code)
        }
      }, function (code) {
        deferred.reject(code)
      })
      return deferred.promise
    }

    StorageMailFolder.prototype.removeMessages = function (aMessages, mboxa) {
      if (!aMessages || !aMessages.length) return $q.reject('aMessages is null!')

      const message = new Message()
      const that = this
      return message.remove(aMessages, mboxa).then(_ => {
        const removeMessageIds = map(aMessages, item => item.messageInfo.id)
        const newMessages = filter(that.messages, item => !~removeMessageIds.indexOf(item.messageInfo.id))
        that.totals -= that.messages.length - newMessages.length
        that.messages = newMessages
      })
    }

    /** todo: moveMsgsToFolder 和 removeMessages 逻辑可重构 */
    StorageMailFolder.prototype.moveMsgsToFolder = function (aMessages, oFolder, mboxa) {
      if (aMessages && aMessages.length > 0) {
        const message = new Message()
        const deferred = message.moveToFolder(aMessages, oFolder, mboxa)
        for (let i = 0; i < aMessages.length; ++i) {
          for (let j = 0; j < this.messages.length; ++j) {
            if (aMessages[i].messageInfo.id == this.messages[j].messageInfo.id) {
              this.messages.splice(j, 1)
              this.totals--
            }
          }
        }
        return deferred
      }
    }

    StorageMailFolder.prototype.getMessages = function () {
      return this.messages
    }

    return StorageMailFolder
  }]



// WEBPACK FOOTER //
// ./src/js/mail/StorageMailFolder.js